import { render, staticRenderFns } from "./PurchasesTableRecapProviders.vue?vue&type=template&id=495dbf47"
import script from "./PurchasesTableRecapProviders.vue?vue&type=script&lang=js"
export * from "./PurchasesTableRecapProviders.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableRecapProviders.vue?vue&type=style&index=0&id=495dbf47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports